import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../Sidebar/Sidebar';
import classes from './layout.module.scss';
import { Header } from '../Header/Header';

// Architectural summary:
// App shell. Owns the single source of truth for the mobile-nav drawer
// open/close state and threads it to Header (renders the burger trigger,
// mobile-only) and Sidebar (renders the desktop rail + the mobile Drawer).
// Touching this file rewires the burger/drawer relationship for every
// authenticated page.
export const Layout: React.FC = () => {
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

    return (
        <div className={classes.container}>
            <Header onOpenMobileNav={() => setIsMobileNavOpen(true)} />
            <div className={classes.contentWrap}>
                <Sidebar
                    isMobileOpen={isMobileNavOpen}
                    onMobileClose={() => setIsMobileNavOpen(false)}
                />
                <main>
                    <Outlet />
                </main>
            </div>
        </div>
    )
}